import { ElementType } from "../IProcessData";
import { IHttpApiTrigger, Triggers } from "../ITriggerData";
import { IMigrationParameters } from "./index";

export function migrate(migrateParameters: IMigrationParameters) {
    const element = migrateParameters.element;
    if (element &&
        element.type === ElementType.Start &&
        element.selectedTypeId === Triggers.HttpApiTrigger.triggerType) {

        const existingParams: IHttpApiTrigger = element.parameters as any;
        if (existingParams.allowedSchemes  && existingParams.allowedSchemes === "HTTPS,HTTP") {
            const migratedParameters = Object.assign({}, existingParams, {
                allowedSchemes: "HTTP,HTTPS",
            });
            const migratedElement = Object.assign({}, element, { parameters: migratedParameters });
            return migratedElement;
        }
    }
    return element;
}
